import React from "react";

export default function Sparkline({ data, color = "#0055FF", width = 280, height = 56, unit = "ms" }) {
  const vals = data.map((d) => (d == null ? 0 : d));
  if (vals.length < 2) {
    return (
      <div
        style={{ width, height }}
        className="flex items-center justify-center rounded-lg bg-black/[0.03] text-[11px] text-[#94A3B8]"
      >
        אוסף נתונים...
      </div>
    );
  }
  const hi = Math.max(...vals, 1) * 1.15;
  const step = width / (vals.length - 1);
  const points = vals.map((v, i) => `${i * step},${height - (v / hi) * height}`).join(" ");
  const areaPoints = `0,${height} ${points} ${width},${height}`;
  const last = data[data.length - 1];
  const gid = `grad-${color.replace("#", "")}`;

  return (
    <svg width={width} height={height} className="overflow-visible">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon points={areaPoints} fill={`url(#${gid})`} />
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {last != null && (
        <circle
          cx={width}
          cy={height - (last / hi) * height}
          r="3"
          fill={color}
        />
      )}
    </svg>
  );
}
